import React from "react";

import Info from "./Info";

import EditCard from "uicomponents/EditCard";

import { sectionsQuestions } from "pages/WorkersCompApplcation/utils/sectionsQuestions";
import { AppDocumentType, BusinessDescriptionType } from "types";
import { WebsitesListInfo } from "./WebsitesListInfo";

interface IAboutYourBusinessReviewProps {
  data: any;
  setActiveStepIndex: (index: number) => void;
  sectionNumber: number;
  documents: AppDocumentType;
}

type TDataEntries = [keyof BusinessDescriptionType, string];

const AboutYourBusinessReview = ({
  data,
  setActiveStepIndex,
  sectionNumber,
  documents,
}: IAboutYourBusinessReviewProps): JSX.Element => {
  if (!data) {
    return <></>;
  }

  const questions = Object.entries(
    sectionsQuestions.aboutYourBusiness.questions
  ) as TDataEntries[];

  return (
    <EditCard
      title={`${sectionsQuestions.aboutYourBusiness.title}`}
      onEditClick={() => setActiveStepIndex(sectionNumber)}
    >
      {questions.map(([key, value]) => {
        if (key === "website") {
          return (
            <WebsitesListInfo key={key} websites={data[key]} question={value} />
          );
        }

        if (key === "verifyCompanyUrl") {
          return (
            <Info
              key={key}
              question={value}
              answer={
                documents?.find((item) => item.applicationField === key)
                  ?.fileName
              }
              questionFieldName={key}
            />
          );
        }

        return (
          <Info
            key={key}
            question={value}
            answer={data?.companyInformation?.[key]}
            questionFieldName={key}
          />
        );
      })}
    </EditCard>
  );
};

export default AboutYourBusinessReview;
